module.exports = __webpack_public_path__ + "static/img/computational_sciences_bg_small.5ff41ca8.jpg";